import { render, staticRenderFns } from "./SfButton.vue?vue&type=template&id=470df11d&scoped=true&functional=true&"
import script from "./SfButton.vue?vue&type=script&lang=js&"
export * from "./SfButton.vue?vue&type=script&lang=js&"
import style0 from "./SfButton.vue?vue&type=style&index=0&id=470df11d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "470df11d",
  null
  
)

export default component.exports